import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FieldDefinition} from "@shared/models/field-definition";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {Router} from "@angular/router";
import {CellValue} from "@shared/models/paged-response-model";
import {CellComponent} from "@shared/components/cell-components/cell-component";

@Component({
    standalone: false,
    selector: 'particle-cbc-common-edit-cell-viewer',
  templateUrl: './cbc-common-edit-cell-viewer.component.html',
  styleUrls: ['./cbc-common-edit-cell-viewer.component.scss']
})
export class CbcCommonEditCellViewerComponent implements OnInit , CellComponent{

  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  fieldDefinition: FieldDefinition;
  item: any;
  editField = true;
  footNoteKey : any;

  constructor() {}

  ngOnInit() {
    //this.disableEditingField(this.item?.cells);
    this.footNoteKey = this.fieldDefinition.key + '_Footnote';
  }

  private disableEditingField(cells: any) {
    if (cells[this.fieldDefinition.key].metaData?.IsReadOnly === true) {
      this.editField = false;
    }
  }

  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }
  openFootNote() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, noteKey: this.footNoteKey ,action: {id: 'OpenNote'}})
  }
}
